export interface VendorFormData {
  vendor_name: string;
  prefix: string;
  first_name: string;
  last_name: string;
  suffix: string;
  phone_type: string;
  phone_number: string;
  ext: string;
  email_type: string;
  email_address: string;
  job_title: string;
  department: string;
  street_address: string;
  unit: string;
  address_line_2: string;
  city: string;
  zip_code: string;
  vendor_state: string;
  notes: string;
  payment_term: string;
  distributor_type_code: string;
}

export const VENDOR_FORM_INITIAL: VendorFormData = {
  vendor_name: "",
  prefix: "",
  first_name: "",
  last_name: "",
  suffix: "",
  phone_type: "",
  phone_number: "",
  ext: "",
  email_type: "",
  email_address: "",
  job_title: "",
  department: "",
  street_address: "",
  unit: "",
  address_line_2: "",
  city: "",
  zip_code: "",
  vendor_state: "",
  notes: "",
  payment_term: "",
  distributor_type_code: "",
};

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS",
  "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY",
  "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV",
  "WI", "WY",
];
